import React, { useCallback, useState } from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';

import { RIGHT, LEFT, PRESSURE } from 'store/examinations';
import MultiAnswerInput from 'components/MultiAnswerInput';
import ContainerWithHistory from '../ContainerWithHistory';

import History from './History';

const PressureForm = ({ side, readMode }) => {
  const [isOpened, setOpened] = useState(false);
  const [{ value = [] }, { error }, { setValue }] = useField([side, PRESSURE].join('.'));

  const handleMultiInput = useCallback((data = '') => setValue(data), [setValue]);

  return (
    <ContainerWithHistory
      label={`Augendruck ${side === RIGHT ? 'OD' : 'OS'} (in mmHg)`}
      isOpened={isOpened}
      setOpened={setOpened}
    >
      <MultiAnswerInput
        type="text"
        values={value}
        handleListChange={handleMultiInput}
        {...(readMode ? { readMode } : { errors: error })}
      />
      <History side={side} isOpened={isOpened} />
    </ContainerWithHistory>
  );
};

PressureForm.propTypes = {
  side: PropTypes.oneOf([RIGHT, LEFT]).isRequired,
  readMode: PropTypes.bool.isRequired,
};

export default PressureForm;
